
const initHeaderScroll = () => {
  const header = document.querySelector("header");

  if (!header) {
    return;
  }

  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY <= 0) {
      header.classList.remove('scroll-up', 'scroll-down', 'scrolled');
      return;
    }

    header.classList.add('scrolled');

    if (currentScrollY > lastScrollY) {
      header.classList.add('scroll-down');
      header.classList.remove('scroll-up');
    } else {
      header.classList.add('scroll-up');
      header.classList.remove('scroll-down');
    }

    lastScrollY = currentScrollY;
  });
};

export default initHeaderScroll;
